import { LitElement, html, css } from 'vendor/lit'
import { updateQuantity } from 'utils/requests'
import { reRenderShopifySections } from 'utils/shopify'
import { visuallyHidden } from 'lib/styles/mixins'
import 'component/cart-remove-button'

class HHInlineCart extends LitElement {
  static properties = {
    loading: {
      reflect: true,
    },
    _trapFocus: {
      state: true,
    },
  }

  constructor() {
    super()
    const self = this

    this.cartItems = this.querySelectorAll('.cart-item')
    this.selectedRecommendation = ''

    this.locales = {
      isLoading() {
        return 'Is Loading'
      },
    }
  }

  async onChange(event) {
    const cartItemLoader = event.target
      .closest('.cart-item')
      .querySelector('.cart-item__loader')

    this.loading = true
    cartItemLoader.classList.add('is-loading')

    document.activeElement.blur()

    reRenderShopifySections(
      await updateQuantity(
        event.detail.key,
        event.detail.value || 0,
        'inline-cart,header'
      )
    )

    this.loading = false
    cartItemLoader.classList.remove('is-loading')
  }

  async onRemove(event) {
    event?.detail?.event?.preventDefault()
    await this.onChange(event)
  }

  render() {
    return html`<div>
      <slot name="error"></slot>
      <slot
        name="body"
        @changeQuantity="${this.onChange}"
        @removeItem="${this.onRemove}"
      ></slot>
      <div>
        <p
          class="visually-hidden"
          aria-live="polite"
          aria-hidden="${this.loading ? false : true}"
          role="status"
        >
          ${this.locales.isLoading()}
        </p>
      </div>
    </div> `
  }

  static styles = [visuallyHidden, css``]
}

customElements.define('hh-inline-cart', HHInlineCart)
